import { type FC, Suspense } from 'react'

import { lazyIcons } from '@redteclab/brand-icons/lazy'

import { BrandIcon } from 'base-ui'

import { type StoryblokServicesListItemType } from '../../storyblok'

export const StoryblokServicesListItemIcon: FC<{
  icon: StoryblokServicesListItemType['icon']
}> = ({ icon }) => {
  if (typeof icon !== 'string') {
    return null
  }

  const SvgIcon = Object.entries(lazyIcons).find(([key]) => key === icon)?.[1]

  if (!SvgIcon) {
    return null
  }

  return (
    <Suspense>
      <BrandIcon
        className="mr-3 size-12 shrink-0 desktop:size-8"
        icon={SvgIcon}
      />
    </Suspense>
  )
}
